<template>
  <ConfigErrorBoundary>
    <FileConverter :config="converterConfig" @batch-created="handleBatchCreated" @job-completed="handleJobCompleted" @batch-cleared="handleBatchCleared" @error="handleError" @credits-updated="handleCreditsUpdated" />
  </ConfigErrorBoundary>
</template>
<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';
const converterConfig = parseAndValidateConverterConfig('pef-to-webp-converter', 'Pentax PEF → WebP');
function handleBatchCreated(batchId: string) { console.log('[PEF to WebP] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[PEF to WebP] Job completed:', jobId); }
function handleBatchCleared() { console.log('[PEF to WebP] Batch cleared'); }
function handleError(error: Error) { console.error('[PEF to WebP] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[PEF to WebP] Credits updated:', credits); }
</script>
